import { instance } from '../../config/intercepter';

// todo check post method
export const getDriversFn = async () => {
  const response = await instance.get('api/drivers');
  return response.data;
};

export const getDriversForCarFn = async (plateNumber) => {
  const response = await instance.get(`api/drivers?hide=${plateNumber}`);
  return response.data;
};

export const addNewDriversFn = async (payload) => {
  const response = await instance.post('api/drivers', payload);
  return response.data;
};

export const editDriversFn = async (driverId, payload) => {
  const response = await instance.put(`api/drivers/${driverId}`, payload);
  return response.data;
};

export const addDriverFn = async () => {
  const response = await instance.get('api/drivers/create');
  return response.data;
};

export const assignDriverFn = async (payload) => {
  const response = await instance.post('api/drivers/assign', {plateno:payload.plateno, userIds:[payload.id]});
  return response.data;
};

export const getDriversByPlateNumberFn = async (plateNo) => {
  const response = await instance.get(`api/drivers/plateno/${plateNo}`);
  return response.data;
};

export const updatePrimaryDriverFn = async (payload) => {
  const response = await instance.post(`api/drivers/setPrimary`, payload);
  return response.data;
};

export const unassignDriverFn = async (payload) => {
  const response = await instance.post(`api/drivers/unassign`, {plateno:payload.plateno, userIds:[payload.id]});
  return response.data;
};

export const getDriverFn = async (driver) => {
  const response = await instance.get(`api/drivers/${driver}`);
  return response.data;
};

export const deleteDriverFn = async (driver) => {
  const response = await instance.delete(`api/drivers/${driver}`);
  return response.data;
};

export const getDriverEditFn = async (driver) => {
  const response = await instance.get(`api/drivers/${driver}/edit`);
  return response.data;
};

export const getUploadedDriverListFn = async () => {
  const response = await instance.get(`api/imports/importDrivers`);
  return response.data;
};

export const getUploadedDriverDetailsFn = async ({ id, count, pageParam }) => {
  const response = await instance.get(
    `api/imports/importDrivers/${id}?show=all&length=${count}&page=${pageParam}`
  );
  return response.data;
};

export const uploadDriverFn = async (payload) => {
  const response = await instance.post(`api/importdrivers`, payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};
